import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { GridsterConfig, GridsterItem } from "angular-gridster2";
import { CompactType, DisplayGrid, GridType } from "angular-gridster2";
// import { LayoutService } from "../../services/layout.service";
import { LayoutService, IComponent } from "src/app/services/layout.service";
import { MatDialog } from "@angular/material";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { DataService } from "src/app/data.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { MatRadioChange } from "@angular/material";
import { Subscription } from "rxjs";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-test-dashboard",
  templateUrl: "./test-dashboard.component.html",
  styleUrls: ["./test-dashboard.component.scss"]
})
export class TestDashboardComponent implements OnInit {
  @ViewChild("widgetDialog", { static: false }) widgetDialog!: TemplateRef<any>;
  @ViewChild("saveDialog", { static: false }) saveDialog!: TemplateRef<any>;
  isEditing: boolean = false;

  selectedItem: any; // Variable to store the selected item object
  // layout: GridsterItem[] = [];
  layout: any[] = [];

  selectedIndex: number = -1;

  private layoutChangeSubscription: Subscription;
  dialogRef: any;
  data: any = {};
  folders: Array<any>;
  reports: Array<any>;
  isLoading = false;
  isError = false;
  errorMessage = "";
  guid: GUID;
  mode = "";
  dashboard: any = {};
  dashboardComponent = [];
  dashboardId = "";
  dashboardName = "";
  dashboardJsontextId = "";
  dashboardcomponentId = "";
  selectedChart: any = "";
  selectedReportId: any = "";
  decimalPlacesList: any[] = ["Automatic", "0", "1", "2", "3", "4", "5"];
  displayUnitsList: any[] = [
    "Shortened Number",
    "Full Number",
    "Hundreds",
    "Thousands",
    "Millions",
    "Billions",
    "Trillions"
  ];
  typeList: any[] = ["LoggedInUser", "SpecifiedUser", "MyTeamUser"];

  setSelectedItem(item: any): void {
    console.log(item);
    this.selectedItem = item;
    this.selectedReportId = item.reportid;
    this.selectedIndex = this.layout.findIndex((i) => i.id === item.id); // Store the index of the selected item
    console.log(this.selectedIndex);
    console.log(this.selectedReportId);
  }
  // Function to handle radio button selection
  radioSelected(event: MatRadioChange): void {
    console.log(event);
    console.log(this.selectedItem);
    // console.log(index);
    console.log(this.selectedIndex);

    // this.layout[index].selectedIcon = event.value;
  }

  widgetForm = this.fb.group({
    id: "",
    report: "",
    reportid: "",
    reportname: "",
    name: "",
    charttype: "",
    xaxis: "",
    yaxis: "",
    customlink: "",
    title: "",
    subtitle: "",
    footer: "",
    maxgroupsdisplay: ["", [Validators.required, Validators.max(100)]],
    decimalplaces: "",
    displayunits: "",
    theme: "Light",
    showvalues: false,
    showpercentages: false,
    combinesmallgroups: false,
    showtotal: false,
    showrange: false,
    cumulative: false,
    stackfull: false,
    plotonsecondaxis: false,
    x: 0,
    y: 0,
    columns: 0,
    rows: 0
  });

  saveForm = this.fb.group({
    report: "",
    reportid: "",
    reportname: "",
    name: "",
    title: "",
    description: "",
    type: "",
    runninguserid: "",
    folder: "",
    folderid: "",
    foldername: "",
    palette: "Aurora",
    theme: "Light",
    gridsize: "12 Columns"

    // iconname: "",
  });

  get options(): GridsterConfig {
    return this.layoutService.options;
  }

  // get options(): GridsterConfig {
  //   return {
  //     draggable: {
  //       enabled: true,
  //     },
  //     pushItems: true,
  //     resizable: {
  //       enabled: true,
  //     },
  //     maxCols: 12, // Set maximum columns to 12
  //     minCols: 12, // Optionally, set minimum columns to 12 as well
  //     defaultItemCols: 12, // Optionally, set default item cols to 12
  //     displayGrid: DisplayGrid.Always, // Optionally, adjust display grid
  //     gridType: GridType.Fit, // Optionally, adjust grid type
  //     compactType: CompactType.None, // Optionally, adjust compact type
  //   };
  // }
  //

  // get layout(): GridsterItem[] {
  //   return this.layoutService.layout;
  // }
  get components(): IComponent[] {
    return this.layoutService.components;
  }
  constructor(
    private layoutService: LayoutService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;

      this.dashboardId = this.route.snapshot.params.id;
      this.dashboardName = this.route.snapshot.params.name;
    });
    console.log(this.mode);
    console.log(this.dashboardId);
    if (this.mode == "edit") {
      this.getDashboardById();
    }
    this.getFolder();
    this.getReport();
    this.guid = new GUID();

    this.layout = this.layoutService.layout;
    this.layoutChangeSubscription =
      this.layoutService.itemChangeSubject.subscribe(
        (layout: GridsterItem[]) => {
          this.layout = layout;
          this.data = layout;
        }
      );

    console.log(this.options);
  }

  ngOnDestroy(): void {
    if (this.layoutChangeSubscription) {
      this.layoutChangeSubscription.unsubscribe();
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  handleItemResize(item: GridsterItem): void {
    this.layoutService.handleItemResize(item); // Call the service method to handle resizing
  }

  widgetdialog(): void {
    this.dialogRef = this.dialog.open(this.widgetDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result === "confirm") {
        // Update the name of the selected field in the grid data
        // this.selectedFieldNameMap[field.sectionName] = field;
        // this.layoutService.addItem();
      }
    });
  }

  confirm() {
    if (this.widgetForm.controls["reportid"].value.toString().trim() == "") {
      this.showWarning("Report is mandatory");
      return;
    }

    if (this.widgetForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }
    if (this.isEditing) {
      // Perform edit operation
      // Update the properties of the selected item
      // this.layoutService.editItem(this.selectedItem); // Pass the selected item to the service method for editing
    } else {
      // this.layoutService.addItem();
      this.layoutService.addItem(
        this.widgetForm.controls["reportid"].value,
        this.widgetForm.controls["reportname"].value,
        this.widgetForm.controls["name"].value,
        this.widgetForm.controls["charttype"].value,
        this.widgetForm.controls["xaxis"].value,
        this.widgetForm.controls["yaxis"].value,
        this.widgetForm.controls["customlink"].value,
        this.widgetForm.controls["title"].value,
        this.widgetForm.controls["subtitle"].value,
        this.widgetForm.controls["footer"].value,
        this.widgetForm.controls["maxgroupsdisplay"].value,
        this.widgetForm.controls["decimalplaces"].value,
        this.widgetForm.controls["displayunits"].value,
        this.widgetForm.controls["theme"].value,
        this.widgetForm.controls["showvalues"].value,
        this.widgetForm.controls["showpercentages"].value,
        this.widgetForm.controls["combinesmallgroups"].value,
        this.widgetForm.controls["showtotal"].value,
        this.widgetForm.controls["showrange"].value,
        this.widgetForm.controls["cumulative"].value,
        this.widgetForm.controls["stackfull"].value,
        this.widgetForm.controls["plotonsecondaxis"].value
      ); // Pass the selected reportid from the form
    }
    this.dialogRef.close(this.widgetForm.value);
  }

  editItem(item: any) {
    this.isEditing = true;

    console.log(item);

    this.widgetForm.controls["name"].setValue(item.name);
    this.widgetForm.controls["reportid"].setValue(item.reportid);
    this.widgetForm.controls["report"].setValue(item.reportid);
    this.widgetForm.controls["reportname"].setValue(item.reportname);
    this.widgetForm.controls["id"].setValue(item.id);

    // this.widgetForm.controls["type"].setValue(item.type);
    this.widgetForm.controls["charttype"].setValue(item.charttype);
    this.widgetForm.controls["title"].setValue(item.title);
    this.widgetForm.controls["subtitle"].setValue(item.subtitle);
    this.widgetForm.controls["footer"].setValue(item.footer);
    // this.widgetForm.controls["legendposition"].setValue(item.legendposition);
    this.widgetForm.controls["theme"].setValue(item.theme);
    this.widgetForm.controls["xaxis"].setValue(item.xaxis);
    this.widgetForm.controls["yaxis"].setValue(item.yaxis);
    this.widgetForm.controls["plotonsecondaxis"].setValue(
      item.plotonsecondaxis
    );
    // this.widgetForm.controls["stackby"].setValue(item.stackby);
    this.widgetForm.controls["stackfull"].setValue(item.stackfull);
    // this.widgetForm.controls["sortby"].setValue(item.sortby);
    // this.widgetForm.controls["thensortby"].setValue(item.thensortby);
    this.widgetForm.controls["customlink"].setValue(item.customlink);
    this.widgetForm.controls["decimalplaces"].setValue(item.decimalplaces);
    this.widgetForm.controls["displayunits"].setValue(item.displayunits);
    this.widgetForm.controls["showvalues"].setValue(item.showvalues);
    this.widgetForm.controls["showpercentages"].setValue(item.showpercentages);
    this.widgetForm.controls["combinesmallgroups"].setValue(
      item.combinesmallgroups
    );
    this.widgetForm.controls["showtotal"].setValue(item.showtotal);
    this.widgetForm.controls["showrange"].setValue(item.showrange);
    this.widgetForm.controls["cumulative"].setValue(item.cumulative);
    this.widgetForm.controls["maxgroupsdisplay"].setValue(
      item.maxgroupsdisplay
    );
    this.widgetForm.controls["x"].setValue(item.xvalue);
    this.widgetForm.controls["y"].setValue(item.yvalue);
    this.widgetForm.controls["columns"].setValue(item.columns);
    this.widgetForm.controls["rows"].setValue(item.rows);

    // Open dialog to edit the widget
    this.dialogRef = this.dialog.open(this.widgetDialog, {
      height: "400px",
      width: "800px",
      // data: this.widgetForm.value, // Pass the item to the dialog
      data: this.widgetForm.value // Pass the item to the dialog
    });

    // Handle dialog close event if needed
    this.dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        console.log("Dialog result:", result);
        this.layoutService.editItem(result);

        // Additional processing if needed
      } else {
        console.log("Dialog Not result:");
      }

      console.log(this.widgetForm.value);

      console.log("The dialog was closed.");
      this.isEditing = false; // Reset flag when dialog is closed
      // if (this.widgetForm.value) {
      //   console.log('Updated item:', this.widgetForm.value);
      //   // Call the editItem method of the LayoutService passing the updated item
      //   this.layoutService.editItem(this.widgetForm.value);
      // }

      // if (result === "confirm") {
      // Update the name of the selected field in the grid data
      // this.selectedFieldNameMap[field.sectionName] = field;
      // this.layoutService.addItem();
      // }
    });
  }

  close() {
    this.dialogRef.close();
  }

  savedialog(): void {
    // Open the dialog with the initialized data
    this.dialogRef = this.dialog.open(this.saveDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result === "confirmation") {
        // Update the name of the selected field in the grid data
        // this.selectedFieldNameMap[field.sectionName] = field;
        this.save();
      }
    });
  }
  confirmation(): void {
    if (this.saveForm.controls["description"].value.toString().trim() == "") {
      this.showWarning("Description is mandatory");
      return;
    }
    if (this.saveForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Dashboard name is mandatory");
      return;
    }
    // if (this.widgetForm.controls["name"].value.toString().trim() == "") {
    //   this.showWarning("Add Atleast one Dashboard Component");
    //   return;
    // }
    if (this.saveForm.controls["folder"].value.toString().trim() == "") {
      this.showWarning("Select the Folder to Save");
      return;
    }
    this.dialogRef.close("confirmation");
  }

  folderChange(event: { value: string; label: string }) {
    if (event.value.trim() !== "") {
      // this.reportTypeId = event.value;
      this.saveForm.controls["folderid"].setValue(event.value);
      this.saveForm.controls["foldername"].setValue(event.label);
    } else {
      this.saveForm.controls["folderid"].setValue("");
      this.saveForm.controls["foldername"].setValue("");
    }
  }

  reportChange(event: { value: string; label: string }, item: GridsterItem) {
    console.log(item);
    if (event.value.trim() !== "") {
      // this.reportTypeId = event.value;
      this.widgetForm.controls["reportid"].setValue(event.value);
      this.widgetForm.controls["reportname"].setValue(event.label);
      this.widgetForm.controls["title"].setValue(event.label);
    } else {
      this.widgetForm.controls["reportid"].setValue("");
      this.widgetForm.controls["reportname"].setValue("");
    }
  }
  decimalplacesChange(event: any) {
    console.log(event);
    this.widgetForm.controls["decimalplaces"].setValue(event);
  }
  displayunitsChange(event: any) {
    console.log(event);
    this.widgetForm.controls["displayunits"].setValue(event);
  }

  getIconName(charttype: string): string {
    const iconMap: { [key: string]: string } = {
      ColumnChart: "view_column",
      HorizontalBarChart: "format_align_left",
      LineChart: "view_headline",
      DonutChart: "donut_large",
      MeterGauge: "shutter_speed",
      FunnelChart: "filter_list",
      MetricChart: "linear_scale",
      PieChart: "pie_chart",
      ScatterChart: "scatter_plot",
      StackedHorizontalBarChart: "format_align_left",
      StackedVerticalBarChart: "bar_chart",
      VerticalBarChart: "bar_chart",
      TableView: "table_chart",
      PercentageChart: "precentage_chart",
      EventChart: "event",
      TaskChart: "event_available"
    };

    return iconMap[charttype] || "";
  }

  getFolder() {
    return new Promise((resolve, reject) => {
      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );

      this.isLoading = true;
      this.dataService.getFolders(organizationid, domain, subdomain).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allFolders = res.data.folder;
            var foldArr = [];
            //just add an empty entry sice this field is optional
            foldArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allFolders.length; i++) {
              foldArr.push({
                value: allFolders[i].id,
                label: allFolders[i].name
              });
            }

            this.folders = foldArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No Folder data!");
            this.errorMessage = res != null ? res.message : "No Folder data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getReport() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService.getReports(organizationid, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")
          // this.router.navigate(['home/globalaction'])
          // window.location.reload();
          var allReports = res.data.report;
          var repArr = [];
          //just add an empty entry sice this field is optional
          repArr.push({ value: "", label: "--None--" });
          for (let i = 0; i < allReports.length; i++) {
            repArr.push({
              value: allReports[i].id,
              label: allReports[i].reportlabel
            });
          }

          this.reports = repArr;
          this.isLoading = false;
        } else {
          console.log("error in getting data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getDashboardById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          dashboard: {
            id: this.dashboardId
          }
        }
      };
      console.log(this.dashboardId);
      this.isLoading = true;
      this.layout = [];
      this.layoutService.layout = [];
      this.dataService.getDashboardById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // this.reporttype = res.data.reporttype;
            this.dashboard = res.data.dashboard;
            this.dashboardComponent = res.data.dashboardcomponent;
            // this.layout = res.data.dashboardcomponent;
            const dashboardComp = res.data.dashboard.dashboardcomponent;

            console.log(dashboardComp);
            console.log(this.dashboardComponent);

            // var rep = res.data.report;
            // this.report = rep

            // console.log("Doneeee****", this.reporttype.name);
            if (this.dashboard != null) {
              this.saveForm.controls["folder"].setValue(
                this.dashboard.folderid
              );
              this.saveForm.controls["folderid"].setValue(
                this.dashboard.folderid
              );
              this.saveForm.controls["name"].setValue(this.dashboard.name);
              this.saveForm.controls["title"].setValue(this.dashboard.title);
              this.saveForm.controls["description"].setValue(
                this.dashboard.description
              );
              this.saveForm.controls["type"].setValue(this.dashboard.type);
              this.saveForm.controls["runninguserid"].setValue(
                this.dashboard.runninguserid
              );
              this.saveForm.controls["gridsize"].setValue(
                this.dashboard.gridsize
              );
              this.saveForm.controls["theme"].setValue(this.dashboard.theme);
              this.saveForm.controls["palette"].setValue(
                this.dashboard.palette
              );

              if (dashboardComp) {
                console.log("dashboardComp", dashboardComp);
                dashboardComp.forEach((dashboardcomp) => {
                  const id = dashboardcomp.id;

                  // Check if the id already exists in layout
                  const alreadyExists = this.layout.some(
                    (item) => item.id === id
                  );
                  if (alreadyExists) {
                    console.log(
                      `Component with id ${id} already exists. Skipping.`
                    );
                    return;
                  }

                  const existingComp = {
                    id: dashboardcomp.id,
                    x:
                      typeof dashboardcomp.xvalue === "string"
                        ? parseInt(dashboardcomp.xvalue)
                        : dashboardcomp.xvalue,
                    y:
                      typeof dashboardcomp.yvalue === "string"
                        ? parseInt(dashboardcomp.yvalue)
                        : dashboardcomp.yvalue,
                    rows:
                      typeof dashboardcomp.rows === "string"
                        ? parseInt(dashboardcomp.rows)
                        : dashboardcomp.rows,
                    cols:
                      typeof dashboardcomp.columns === "string"
                        ? parseInt(dashboardcomp.columns)
                        : dashboardcomp.columns,
                    reportid: dashboardcomp.reportid,
                    reportname: dashboardcomp.reportname,
                    dashboardid: dashboardcomp.dashboardid,
                    name: dashboardcomp.name,
                    type: dashboardcomp.type,
                    charttype: dashboardcomp.charttype,
                    title: dashboardcomp.title,
                    subtitle: dashboardcomp.subtitle,
                    footer: dashboardcomp.footer,
                    legendposition: dashboardcomp.legendposition,
                    theme: dashboardcomp.theme,
                    xaxis: dashboardcomp.xaxis,
                    yaxis: dashboardcomp.yaxis,
                    plotonsecondaxis: dashboardcomp.plotonsecondaxis,
                    stackby: dashboardcomp.stackby,
                    stackfull: dashboardcomp.stackfull,
                    sortby: dashboardcomp.sortby,
                    thensortby: dashboardcomp.thensortby,
                    customlink: dashboardcomp.customlink,
                    decimalplaces: dashboardcomp.decimalplaces,
                    displayunits: dashboardcomp.displayunits,
                    showvalues: dashboardcomp.showvalues,
                    showpercentages: dashboardcomp.showpercentages,
                    combinesmallgroups: dashboardcomp.combinesmallgroups,
                    showtotal: dashboardcomp.showtotal,
                    showrange: dashboardcomp.showrange,
                    cumulative: dashboardcomp.cumulative,
                    maxgroupsdisplay: dashboardcomp.maxgroupsdisplay
                  };

                  this.layout.push(existingComp);
                  console.log("Section Pushed", this.layout);
                });
              }
            }

            // if (this.dashboard != null) {
            //   // this.metaLayoutId = this.metaglobalaction.metalayoutid;
            //   // this.metaactionId = this.metaglobalaction.id;
            //   // this.metaactionName = this.metaglobalaction.name;
            //   // this.detailForm.controls["primaryobject"].setValue(
            //   //   this.reporttype.primaryobjectname
            //   // );
            //   this.saveForm.controls["folder"].setValue(
            //     this.dashboard.folderid
            //   );
            //   this.saveForm.controls["folderid"].setValue(
            //     this.dashboard.folderid
            //   );
            //   this.saveForm.controls["name"].setValue(this.dashboard.name);
            //   this.saveForm.controls["title"].setValue(this.dashboard.title);
            //   this.saveForm.controls["description"].setValue(
            //     this.dashboard.description
            //   );
            //   this.saveForm.controls["type"].setValue(this.dashboard.type);
            //   this.saveForm.controls["runninguserid"].setValue(
            //     this.dashboard.runninguserid
            //   );
            //   this.saveForm.controls["gridsize"].setValue(
            //     this.dashboard.gridsize
            //   );
            //   this.saveForm.controls["theme"].setValue(this.dashboard.theme);
            //   this.saveForm.controls["palette"].setValue(
            //     this.dashboard.palette
            //   );
            //   if (dashboardComp) {
            //     console.log("dashboardComp", dashboardComp);
            //     const mappeddashboardComp = dashboardComp.map(
            //       (dashboardcomp) => {
            //         const existingComp = {
            //           id: dashboardcomp.id,
            //           // x: dashboardcomp.xvalue,
            //           // y: dashboardcomp.yvalue,
            //           // rows: dashboardcomp.rows,
            //           // cols: dashboardcomp.columns,
            //           x:
            //             typeof dashboardcomp.xvalue === "string"
            //               ? parseInt(dashboardcomp.xvalue)
            //               : dashboardcomp.xvalue,
            //           y:
            //             typeof dashboardcomp.yvalue === "string"
            //               ? parseInt(dashboardcomp.yvalue)
            //               : dashboardcomp.yvalue,
            //           rows:
            //             typeof dashboardcomp.rows === "string"
            //               ? parseInt(dashboardcomp.rows)
            //               : dashboardcomp.rows,
            //           cols:
            //             typeof dashboardcomp.columns === "string"
            //               ? parseInt(dashboardcomp.columns)
            //               : dashboardcomp.columns,
            //           reportid: dashboardcomp.reportid,
            //           reportname: dashboardcomp.reportname,
            //           dashboardid: dashboardcomp.dashboardid,
            //           name: dashboardcomp.name,
            //           type: dashboardcomp.type,
            //           charttype: dashboardcomp.charttype,
            //           title: dashboardcomp.title,
            //           subtitle: dashboardcomp.subtitle,
            //           footer: dashboardcomp.footer,
            //           legendposition: dashboardcomp.legendposition,
            //           theme: dashboardcomp.theme,
            //           xaxis: dashboardcomp.xaxis,
            //           yaxis: dashboardcomp.yaxis,
            //           plotonsecondaxis: dashboardcomp.plotonsecondaxis,
            //           stackby: dashboardcomp.stackby,
            //           stackfull: dashboardcomp.stackfull,
            //           sortby: dashboardcomp.sortby,
            //           thensortby: dashboardcomp.thensortby,
            //           customlink: dashboardcomp.customlink,
            //           decimalplaces: dashboardcomp.decimalplaces,
            //           displayunits: dashboardcomp.displayunits,
            //           showvalues: dashboardcomp.showvalues,
            //           showpercentages: dashboardcomp.showpercentages,
            //           combinesmallgroups: dashboardcomp.combinesmallgroups,
            //           showtotal: dashboardcomp.showtotal,
            //           showrange: dashboardcomp.showrange,
            //           cumulative: dashboardcomp.cumulative,
            //           maxgroupsdisplay: dashboardcomp.maxgroupsdisplay,

            //           // systemSection: dashboardcomp.systemsection,
            //           // column: parseInt(dashboardcomp.columncount),
            //           // groupsequence: dashboardcomp.groupsequence,
            //           // droppedDataFieldList: [],
            //         };

            //         this.layout.push(existingComp);

            //         console.log("Section Pushed", this.layout);

            //         console.log("Section Pushed");
            //       }
            //     );
            //     // return mappedSections;
            //     // this.sectionList.sort(function (a, b) {
            //     //   console.log("aaaaaaaaa", b);
            //     //   return a.groupsequence - b.groupsequence; // Adjust the property based on which you want to sort
            //     // });
            //   }
            // }

            // this.detailForm.controls["name"].setValue(this.reporttype.)

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("no data");
            this.isLoading = false;
            resolve(null);

            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);

          //this.resetDetailFormControls();
        }
      );
    });
  }

  getWidgetOrder(layout: GridsterItem[]): { id: string; order: number }[] {
    // Create a copy of the layout array to avoid mutating the original array
    const sortedLayout = [...layout].sort((a, b) => {
      if (a.y !== b.y) {
        return a.y - b.y;
      }
      return a.x - b.x;
    });

    // Assign order numbers based on the sorted position
    return sortedLayout.map((item, index) => ({
      ...item,
      id: item.id,
      order: index + 1
    }));
  }

  save() {
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
    if (this.mode.toLowerCase() == "new") {
      this.dashboardId = this.guid.getGUID("dashboard");
    }

    console.log("Old Order", this.layout);

    this.layout = this.getWidgetOrder(this.layout);

    // console.log(orderedLayout)

    console.log("Changed Order", this.layout);

    // this.columnsDone.forEach((column) => {
    //   if (column.sortingcolumn == true) {
    //     sortcolumnName = column.fieldname;
    //     sortobjectName = column.section;
    //     this.formGroup.controls["sortcolumnname"].setValue(sortcolumnName);
    //     this.formGroup.controls["sortobjectname"].setValue(sortobjectName);
    //   }
    // });

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        dashboard: {
          mode: this.mode,
          id: this.dashboardId,
          name: this.saveForm.controls["name"].value,
          title: this.saveForm.controls["name"].value,
          description: this.saveForm.controls["description"].value,
          folderid: this.saveForm.controls["folderid"].value,
          type: this.saveForm.controls["type"].value,
          runninguserid: this.saveForm.controls["type"].value,
          gridsize: this.saveForm.controls["gridsize"].value,
          theme: this.saveForm.controls["theme"].value,
          palette: this.saveForm.controls["palette"].value,
          backgrounddirection: "",
          backgroundend: "",
          backgroundstart: "",
          isdeleted: "",
          // leftsize: this.saveForm.controls["leftsize"].value,//
          // middlesize: this.saveForm.controls["middlesize"].value,//
          // rightsize: this.saveForm.controls["rightsize"].value,//
          leftsize: "",
          middlesize: "",
          rightsize: "",
          textcolor: "",
          titlecolor: "",
          titlesize: "",
          dashboardcomponent: [],
          dashboardjsontext: []
        }
      }
    };

    this.layout.forEach((layout, index: any) => {
      this.dashboardcomponentId = this.guid.getGUID("dashboardcomponent");

      var dashboardComponent = {
        id: this.dashboardcomponentId,
        dashboardid: this.dashboardId,
        reportid: layout.reportid,
        reportname: layout.reportname,
        name: layout.name, //
        type: "Chart",
        charttype: layout.charttype,
        title: layout.title, //
        subtitle: layout.title, //
        footer: layout.footer, //
        legendposition: "", //
        theme: layout.theme,
        yaxis: layout.yaxis,
        xaxis: layout.xaxis,
        plotonsecondaxis: layout.plotonsecondaxis, //
        stackby: "",
        stackfull: false,
        sortby: "", //
        thensortby: "", //
        customlink: layout.customlink, //
        decimalplaces: layout.decimalplaces, //
        displayunits: layout.displayunits, //
        showvalues: layout.showvalues, //
        showpercentages: layout.showpercentages, //
        combinesmallgroups: layout.combinesmallgroups, //
        showtotal: layout.showtotal, //
        showrange: layout.showrange, //
        cumulative: layout.cumulative, //
        maxgroupsdisplay: layout.maxgroupsdisplay, //
        xvalue: layout.x,
        yvalue: layout.y,
        rows: layout.rows,
        columns: layout.columns || layout.cols
      };
      // index++;

      postOption.data.dashboard.dashboardcomponent.push(dashboardComponent);
    });

    this.dashboardJsontextId = this.guid.getGUID("dashboardjsontext");
    // }
    var dashboardjsontext = {
      id: this.dashboardJsontextId,
      dashboardid: this.dashboardId,
      dashboardname: this.saveForm.controls["name"].value,
      jsontext: {}
    };

    //push metaprofilelayout to request data (postoption)
    postOption.data.dashboard.dashboardjsontext.push(dashboardjsontext);

    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertDashboard(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/dashboardlist");
        } else {
          console.log("Error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
